/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Start_WhatsappInputs */

const en_messages_start_whatsapp = /** @type {(inputs: Messages_Start_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a WhatsApp conversation`)
};

const he_messages_start_whatsapp = /** @type {(inputs: Messages_Start_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחל שיחת וואטסאפ`)
};

/**
* | output |
* | --- |
* | "Start a WhatsApp conversation" |
*
* @param {Messages_Start_WhatsappInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_start_whatsapp = /** @type {((inputs?: Messages_Start_WhatsappInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Start_WhatsappInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_start_whatsapp(inputs)
	return he_messages_start_whatsapp(inputs)
});